type IconProps = {
  color?: string
  className?: string
}

const A2Logo: React.FC<IconProps> = ({ color = 'currentColor', ...attributes }) => {
  return (
    <svg width="50" height="48" viewBox="0 0 50 48" fill={color} xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M39.9,46.5h-15.5l10.6-12.1,5,12.1h0ZM35.5,31.9l-9.5-22.8c.8-2.5,2.2-4.5,4.2-5.8,2-1.4,4.3-2,7-2s3,.2,4.3.7c1.3.5,2.5,1.2,3.5,2.1,1,.9,1.7,2.1,2.3,3.4.5,1.3.8,2.8.8,4.4,0,2.4-.8,4.8-2.3,7.1-1.5,2.4-3.5,5-6.1,7.9l-4.3,4.9h0ZM24.5,8.8s0,0,0,0h0s10,24.2,10,24.2h0c0,0-26.4,0-26.4,0L21.4,1.4l3.1,7.4ZM41.6,46.5l-5.5-13.3,4.3-4.9c1.5-1.7,2.8-3.3,4-4.8,1.2-1.4,2.1-2.8,2.9-4.1.8-1.3,1.4-2.6,1.8-3.9.4-1.3.6-2.7.6-4.1s-.3-3.1-.9-4.5c-.6-1.4-1.5-2.6-2.6-3.7-1.1-1-2.4-1.9-3.9-2.4-1.5-.6-3.2-.9-5-.9-3,0-5.7.8-7.9,2.3-1.8,1.2-3.1,2.8-4,4.8L22.4.5h-1.9L0,48h1.6l5.8-13.6h25.8l-10.4,11.9v1.7h27.1v-1.5h-8.4Z"
        fill="#fff"
      />
    </svg>
  )
}

export default A2Logo
